import { Drawer } from "@components";
import { Titles } from "../../variables/Titles";

import FixedValueForm from "../types/FixedValueForm";

export const ProfileSeasonForm = ({
  visible,
  onClose,
  node,
  onSave,
  onRemove,
}) => {
  const options = [
    { label: "Outono", value: 1 },
    { label: "Inverno", value: 2 },
    { label: "Primavera", value: 4 },
    { label: "Verão", value: 8 },
  ];

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={Titles.ProfileSeason}
      direction="center-right"
      parentSelector={() => document.getElementById("oracle-flow")}
    >
      <FixedValueForm
        timerange={false}
        node={node}
        options={options}
        onSave={(node) => onSave(node)}
        onRemove={onRemove}
      />
    </Drawer>
  );
};
